import { fetchDataFromBackend } from "../api/api";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

export const UserSettingsService = {
    /**
     * Get user settings for the authenticated user
     */
    async getUserSettings() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Returning default user settings.");
                return {
                    id: 1,
                    userId: 1,
                    organizationId: "org1",
                    workerSortBy: "Name",
                    workerSortOrder: "Asc",
                    customWorkerOrder: null
                };
            }

            const response = await fetchDataFromBackend("/UserSettings/GetUserSettings", {
                skipAuth: false,
                method: 'get'
            });

            logger.log("User settings response:", response);
            return response;
        } catch (error) {
            if (error.response?.status === 404) {
                // No settings exist yet, return defaults
                logger.log("No user settings found, returning defaults");
                return {
                    workerSortBy: "Name",
                    workerSortOrder: "Asc",
                    customWorkerOrder: null
                };
            }
            logger.error("❌ Error fetching user settings:", error);
            throw error;
        }
    },

    /**
     * Save or update user settings
     */
    async saveUserSettings(settings) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Simulated saving user settings:", settings);
                return settings;
            }

            const response = await fetchDataFromBackend("/UserSettings/SaveUserSettings", {
                skipAuth: false,
                method: 'put',
                data: settings
            });

            logger.log("Save user settings response:", response);
            return response;
        } catch (error) {
            logger.error("❌ Error saving user settings:", error);
            throw error;
        }
    },

    /**
     * Get all user settings for the organization (admin only)
     */
    async getOrganizationSettings() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Returning simulated organization settings.");
                return [
                    {
                        id: 1,
                        userId: 1,
                        organizationId: "org1",
                        workerSortBy: "Name",
                        workerSortOrder: "Asc",
                        customWorkerOrder: null
                    },
                    {
                        id: 2,
                        userId: 2,
                        organizationId: "org1",
                        workerSortBy: "Position",
                        workerSortOrder: "Asc",
                        customWorkerOrder: null
                    }
                ];
            }

            const response = await fetchDataFromBackend("/UserSettings/GetOrganizationSettings", {
                skipAuth: false,
                method: 'get'
            });

            logger.log("Organization settings response:", response);
            return response;
        } catch (error) {
            logger.error("❌ Error fetching organization settings:", error);
            throw error;
        }
    }
};
